module.exports = __webpack_public_path__ + "media/categories/9004-7b6ed07a.svg";